import React from 'react';
import { motion } from 'framer-motion';

interface InkWipeProps {
  direction?: 'forward' | 'backward';
  color?: string;
  duration?: number;
  onComplete?: () => void;
}

/**
 * InkWipe — a crimson bar that sweeps across the screen as a page transition.
 * Mount it during transitions, it auto-completes and calls onComplete.
 */
export const InkWipe: React.FC<InkWipeProps> = ({
  direction = 'forward',
  color = 'var(--c-crimson)',
  duration = 0.55,
  onComplete,
}) => {
  const isForward = direction === 'forward';

  return (
    <motion.div
      className="ink-wipe"
      style={{ background: color }}
      initial={{
        clipPath: isForward
          ? 'inset(0 100% 0 0)'
          : 'inset(0 0 0 100%)',
      }}
      animate={{
        clipPath: [
          isForward ? 'inset(0 100% 0 0)' : 'inset(0 0 0 100%)',
          'inset(0 0 0 0)',
          isForward ? 'inset(0 0 0 100%)' : 'inset(0 100% 0 0)',
        ],
      }}
      transition={{
        duration: duration,
        ease: [0.4, 0, 0.2, 1] as const,
        times: [0, 0.45, 1],
      }}
      onAnimationComplete={onComplete}
    />
  );
};

export default InkWipe;
